
export class DemoUserSerializer {

    private static INSTANCE = new  DemoUserSerializer();

    static get instance() {
        return this.INSTANCE;
    }


    public serializeAppList(payload: any) {
        const apps = payload.apps ? payload.apps : [];
        return apps;
    }

    public guestUserSerializer(payload: any) {
        const guest: any = payload.guest_account;
        const userData: any = {
            username: guest.username,
            password: guest.password,
        };
        return userData;
    }
}

export const demoUserSerializer = DemoUserSerializer.instance;
